import React from "react";
import { motion } from "framer-motion";
import portfolio from "@/data/portfolio";

export default function CredibilityStrip() {
  const c = portfolio.credibility;
  if (!c?.items?.length) return null;

  return (
    <section
      data-testid="credibility-strip"
      aria-label="Institutions and ventures"
      className="border-t border-b hairline bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-10 md:py-14">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col lg:flex-row lg:items-center lg:gap-12 gap-6"
        >
          <div className="flex items-center gap-3 lg:flex-shrink-0">
            <span className="inline-block w-6 h-px bg-black/40" />
            <span className="text-[10px] md:text-xs font-semibold uppercase tracking-[0.22em] text-gray-500">
              {c.eyebrow}
            </span>
          </div>

          <ul className="flex flex-wrap items-center gap-x-8 gap-y-4 md:gap-x-12">
            {c.items.map((name, i) => (
              <motion.li
                key={name}
                initial={{ opacity: 0, y: 8 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.05 * i }}
                data-testid={`credibility-item-${i}`}
                className="font-serif-display text-lg md:text-xl tracking-tight text-black/85 hover:text-black transition-colors whitespace-nowrap"
              >
                {name}
              </motion.li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
